import { useRouter } from "next/navigation";
import { useCheckout } from "./use-checkout";

export const useCTANavigation = () => {
  const router = useRouter();
  const { handleCheckout } = useCheckout();
  const handleScrollToPitch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const el = document.getElementById("pitch");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else router.push("/#pitch");
  };
  const handleScrollToStarterKit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const el = document.getElementById("starter-kit");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else router.push("/#starter-kit");
  };

  const handleBuyNow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    router.push(`/buy-now?${params.toString()}`);
  };

  const actions: Record<
    string,
    (e: React.MouseEvent<HTMLButtonElement>) => void
  > = {
    starter_kit: handleScrollToStarterKit,
    pitch: handleScrollToPitch,
    buy_now: handleBuyNow,
    checkout: handleCheckout,
  };

  return { actions };
};
